// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/dashboard-v3.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPostHog } from './observability/posthog';

initPostHog();

// After a redeploy the previously-hashed chunks are gone from disk. Any tab
// still running the old entry will hit 404s on dynamic imports. Force a
// single reload so the browser picks up the new index HTML + manifest.
const RELOAD_FLAG = 'orgain:reloaded-for-chunk-error';
const reloadForStaleChunks = () => {
  if (sessionStorage.getItem(RELOAD_FLAG)) return;
  sessionStorage.setItem(RELOAD_FLAG, '1');
  window.location.reload();
};
const isChunkLoadError = (err: unknown) => {
  const msg = (err && (err as any).message) || String(err || '');
  const name = err && (err as any).name;
  return name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/i.test(msg) || /Loading CSS chunk/i.test(msg);
};
window.addEventListener('error', (e) => {
  if (isChunkLoadError(e.error) || /\/static\/(js|css)\//.test((e as any).filename || '')) reloadForStaleChunks();
});
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkLoadError(e.reason)) reloadForStaleChunks();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
